import { c as _c } from "react/compiler-runtime";
import type { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import styles from './WatchlistSvg.module.css';
import svgStyles from './SVGStyles.module.css';
import classNames from "classnames";

//#region [Props]
type WatchlistSvgProps = {
  selected?: boolean;
} & StandardSvgProps;

//#endregion

//#region [Component]
export default function WatchlistSvgWithGradient(t0) {
  const $ = _c(18);
  const {
    className,
    selected: t1
  } = t0;
  const selected = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = classNames(svgStyles.SDefaultSvg, styles.SWatchlistSvg, styles.SWatchlistSvgGradient, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== selected) {
    t3 = !selected && <radialGradient id="WatchlistSvgWithGradient" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stopColor="var(--palette-melrose2)" /><stop offset="0.265" stopColor="var(--palette-french-pass)" /><stop offset="0.567" stopColor="var(--palette-your-pink)" /><stop offset="0.764" stopColor="var(--palette-illusion)" /><stop offset="1" stopColor="var(--palette-melrose2)" /></radialGradient>;
    $[2] = selected;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== selected) {
    t4 = selected && <radialGradient id="WatchlistSvgWithGradient" cx="0.5" cy="0.617" r="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stopColor="var(--palette-melrose2)" /><stop offset="0.265" stopColor="var(--palette-french-pass)" /><stop offset="0.567" stopColor="var(--palette-your-pink)" /><stop offset="0.764" stopColor="var(--palette-illusion)" /><stop offset="1" stopColor="var(--palette-melrose2)" /></radialGradient>;
    $[4] = selected;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <defs>{t3}{t4}</defs>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== selected) {
    t6 = !selected && <path d="M-10456,15529a18,18,0,0,1,18-18,18,18,0,0,1,18,18,18,18,0,0,1-18,18A18,18,0,0,1-10456,15529Zm6.688-11.312A15.88,15.88,0,0,0-10454,15529a15.882,15.882,0,0,0,4.687,11.315A15.882,15.882,0,0,0-10438,15545a15.882,15.882,0,0,0,11.314-4.686A15.882,15.882,0,0,0-10422,15529a15.88,15.88,0,0,0-4.687-11.312A15.882,15.882,0,0,0-10438,15513,15.882,15.882,0,0,0-10449.312,15517.687Zm5.649,20.38a1,1,0,0,1-.644-.823,3.307,3.307,0,0,1-.027-.441v-12.942a3.8,3.8,0,0,1,3.793-3.788h4.885a3.8,3.8,0,0,1,3.792,3.788v12.942a2.884,2.884,0,0,1-.016.32,1,1,0,0,1-.632.851,1.012,1.012,0,0,1-1.042-.2l-4.494-4.151-4.589,4.241a1,1,0,0,1-.679.265A1,1,0,0,1-10443.663,15538.066Zm1.331-14.207v11l3.608-3.332a1,1,0,0,1,1.354,0l3.5,3.234v-10.9a1.793,1.793,0,0,0-1.791-1.791h-4.885A1.793,1.793,0,0,0-10442.332,15523.859Z" transform="translate(10456 -15510.999)" />;
    $[9] = selected;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== selected) {
    t7 = selected && <path d="M-10438,15547a17.888,17.888,0,0,1-7.007-1.415,17.932,17.932,0,0,1-5.722-3.857,17.954,17.954,0,0,1-3.856-5.724A17.88,17.88,0,0,1-10456,15529a17.866,17.866,0,0,1,1.414-7,17.955,17.955,0,0,1,3.856-5.723,17.932,17.932,0,0,1,5.722-3.857A17.888,17.888,0,0,1-10438,15511a17.888,17.888,0,0,1,7.007,1.415,17.957,17.957,0,0,1,5.723,3.857,17.947,17.947,0,0,1,3.857,5.723,17.874,17.874,0,0,1,1.415,7,17.881,17.881,0,0,1-1.415,7.007,17.93,17.93,0,0,1-3.857,5.724,17.947,17.947,0,0,1-5.723,3.857A17.888,17.888,0,0,1-10438,15547Zm-2.54-26.93a3.8,3.8,0,0,0-3.793,3.788v12.942a3.223,3.223,0,0,0,.027.441,1,1,0,0,0,.644.823.991.991,0,0,0,.348.062,1,1,0,0,0,.679-.265l4.589-4.241,4.494,4.151a1.014,1.014,0,0,0,.684.266,1,1,0,0,0,.358-.066,1,1,0,0,0,.632-.851,2.809,2.809,0,0,0,.016-.32v-12.942a3.794,3.794,0,0,0-3.792-3.788Zm-1.791,14.787v-11a1.793,1.793,0,0,1,1.791-1.791h4.885a1.793,1.793,0,0,1,1.791,1.791v10.9l-3.5-3.234a1,1,0,0,0-.677-.266,1,1,0,0,0-.678.266l-3.606,3.331Z" transform="translate(10456 -15510.999)" />;
    $[11] = selected;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <svg className={t2} width="36.001" height="36.002" viewBox="0 0 36.001 36.002">{t5}{t6}{t7}</svg>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
//#endregion